module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pixel-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "pixel-spinner-inner",
    style: (_vm.spinnerInnerStyle)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b73faab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/PixelSpinner.vue
// module id = 2215
// module chunks = 1